import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import { ReturnDetailSectionId } from '../../../fulfillment-plan/order-details-expanded-section-provider';
import { EnhancedReturnDetailsLayoutLoader } from '../../../layouts/enhanced-return-details-layout/enhanced-return-details-layout-loader';
import SectionTitle from '../../../tab-section/title';

import { messages } from './messages';
import style from './styles.module.less';

type ReturnDetailsProps = {
  address: React.ReactNode;
  rmaInfo: React.ReactNode;
  costSummary: React.ReactNode;
};

export function ReturnDetails({ address, rmaInfo, costSummary }: ReturnDetailsProps) {
  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      contentClassName={style.content}
      headerContent={<SectionTitle messageDescriptor={messages.sectionHeaderTitle} />}
      sectionContent={
        <EnhancedReturnDetailsLayoutLoader
          addressColumnContent={address}
          costSummaryColumnContent={costSummary}
          rmaColumnContent={rmaInfo}
        />
      }
      sectionId={ReturnDetailSectionId.ReturnDetails}
    />
  );
}
